import MaskText from "@/components/MaskText";
import { motion } from "framer-motion";
import { easeLux } from "@/lib/motion";

// Encabezado editorial reutilizable para páginas interiores
export const PageHero = ({ overline, titleLines = [], intro, testId }) => {
  return (
    <section className="relative overflow-hidden pt-40 pb-16 md:pt-48 md:pb-24" data-testid={testId}>
      <div className="pointer-events-none absolute -right-40 top-20 h-96 w-96 rounded-full bg-powder/40 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.9 }}
          className="mb-6 text-xs md:text-sm uppercase tracking-[0.35em] text-rosegold font-sans"
        >
          {overline}
        </motion.p>
        <h1 className="font-serif font-light tracking-tight text-charcoal text-5xl md:text-6xl lg:text-7xl leading-[1.04]">
          <MaskText lines={titleLines} delay={0.25} />
        </h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.9, ease: easeLux }}
            className="mt-8 max-w-xl font-sans font-light text-base md:text-lg leading-relaxed text-charcoal/70"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
